var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TileCustomLink_link__1wgi1{margin-bottom:10px;font-size:14px;line-height:20px;font-weight:400;display:inline-block;position:relative;color:#42b4e6}.TileCustomLink_link__1wgi1 img{margin-left:10px}.TileCustomLink_link__1wgi1,.TileCustomLink_link__1wgi1:hover{color:#42b4e6}.TileCustomLink_link__1wgi1:after{content:\"\";position:absolute;width:10px;height:20px;margin-left:5px;background:url(" + escape(require("./images/arrow.svg")) + ") no-repeat;background-position:50%}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333",
	"textGray": "#9b9b9b",
	"textWhite": "#fff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"link": "TileCustomLink_link__1wgi1"
};